import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "profile-info d-sm-flex align-items-center mb-10" }
const _hoisted_4 = { class: "m-0" }
const _hoisted_5 = { class: "d-block text-dark-emphasis mb-0 small" }
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-medium text-black-emphasis mb-0" }, null, -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1" }, null, -1 /* HOISTED */)
const _hoisted_9 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_10 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-danger rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-cube" })
], -1 /* HOISTED */)
const _hoisted_12 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_13 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_14 = {
  key: 1,
  class: "position-relative"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-danger rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-user" })
], -1 /* HOISTED */)
const _hoisted_16 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_17 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_18 = {
  key: 2,
  class: "position-relative"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-muted rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-map-pin" })
], -1 /* HOISTED */)
const _hoisted_20 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_21 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_22 = {
  key: 3,
  class: "position-relative"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-envelope-simple" })
], -1 /* HOISTED */)
const _hoisted_24 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 4,
  class: "position-relative"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning-light rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-phone" })
], -1 /* HOISTED */)
const _hoisted_28 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 5,
  class: "position-relative"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-at" })
], -1 /* HOISTED */)
const _hoisted_32 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_33 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.center)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createCommentVNode(" <h1 class=\"text-black fw-medium mb-8\">{{ center.name }}</h1> "),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.center.id), 1 /* TEXT */)
            ])
          ]),
          _createCommentVNode(" <div class=\"border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30\"></div> "),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: { path: `/center/${_ctx.center.id}/edit` },
                  class: "d-inline-block text-decoration-none lh-1 text-muted fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.edit')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["to"]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("ul", _hoisted_9, [
            (_ctx.center.department)
              ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('form.department.label')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.center.department), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.center.main_contractor)
              ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('form.main_contractor.label')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.center.main_contractor), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.center.address || _ctx.center.zip_code || _ctx.center.country)
              ? (_openBlock(), _createElementBlock("li", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('form.address.label')), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.center.address) + " - " + _toDisplayString(_ctx.center.zip_code) + " - " + _toDisplayString(_ctx.center.country), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.center.email)
              ? (_openBlock(), _createElementBlock("li", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: `mailto:${_ctx.center.email}`,
                    class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                  }, _toDisplayString(_ctx.center.email), 9 /* TEXT, PROPS */, _hoisted_25)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.center.phone)
              ? (_openBlock(), _createElementBlock("li", _hoisted_26, [
                  _hoisted_27,
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: `tel:${_ctx.center.phone}`,
                    class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                  }, _toDisplayString(_ctx.center.phone), 9 /* TEXT, PROPS */, _hoisted_29)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.center.website)
              ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t('form.website.label')), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: `https://${_ctx.center.website}`,
                    target: "_blank",
                    class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                  }, _toDisplayString(_ctx.center.website), 9 /* TEXT, PROPS */, _hoisted_33)
                ]))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}